import { AlertDialog, Button, Flex } from '@radix-ui/themes';
import { RadixColor, RX } from 'enums/radix';
import { ReactNode, useState } from 'react';

export const CommonAlert = (props: {
  title: ReactNode;
  description: ReactNode;
  confirmColor?: RadixColor;
  onConfirm?: () => void;
}) => {
  const [open, setOpen] = useState(true);

  return (
    <AlertDialog.Root open={open}>
      <AlertDialog.Content size="2">
        <AlertDialog.Title>{props.title}</AlertDialog.Title>
        <AlertDialog.Description>{props.description}</AlertDialog.Description>

        <Flex justify="end" gap="2" mt="4">
          <AlertDialog.Cancel>
            <Button
              color={RX.CLR.NEUTRAL}
              variant="soft"
              onClick={() => setOpen(false)}
            >
              Cancel
            </Button>
          </AlertDialog.Cancel>

          {props.onConfirm && (
            <AlertDialog.Action>
              <Button
                color={props.confirmColor}
                onClick={() => {
                  props.onConfirm?.();
                  setOpen(false);
                }}
              >
                Confirm
              </Button>
            </AlertDialog.Action>
          )}
        </Flex>
      </AlertDialog.Content>
    </AlertDialog.Root>
  );
};
